import { DigitalProductId } from 'modules/digital-product/types/digital-product-interface'
import { OfferId } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/offer-interface'
import { useStore } from 'modules/stores/store/hooks/use-store'
import { StoreId } from 'modules/stores/types/stores-interface'
import { useItemProductActions } from '../../../hooks/use-item-product-actions'
import {
  ProductDownloadItemEditType,
  ProductDownloadItemViewType,
} from '../../../types/product-interface'
import { getItemUpdateData } from '../../../utils/get-item-update-data'

export const useSaveDownloadItem = ({ storeId }: { storeId: StoreId }) => {
  const { mutate: mutateStore } = useStore(storeId)
  const { createProduct, updateProduct } = useItemProductActions()

  const updateItem = async (
    item: Omit<ProductDownloadItemEditType, 'id'> & { id: number },
    digitalProductId: DigitalProductId,
    offerId: OfferId,
  ) => {
    const mutateProductItemData = async (responseData: ProductDownloadItemViewType) => {
      await mutateStore(
        data =>
          data && {
            ...data,
            items: data.items.map(i => (i.itemId === responseData.itemId ? responseData : i)),
          },
        false,
      )
    }

    const responseData = await updateProduct(
      item.id,
      getItemUpdateData({ item, digitalProductId, offerId }),
    )

    await mutateProductItemData(responseData)
  }

  const createItem = async (
    item: ProductDownloadItemEditType,
    digitalProductId: DigitalProductId,
    offerId: OfferId,
  ) => {
    const mutateProductItemData = async (responseData: ProductDownloadItemViewType) =>
      await mutateStore(data => data && { ...data, items: [...data.items, responseData] }, false)

    const responseData = await createProduct(
      storeId,
      getItemUpdateData({ item, digitalProductId, offerId }),
    )

    await mutateProductItemData(responseData)
  }

  const saveItem = async (
    item: ProductDownloadItemEditType,
    digitalProductId: DigitalProductId,
    offerId: OfferId,
  ) => {
    if (item.id) {
      await updateItem({ ...item, id: item.id }, digitalProductId, offerId)
    } else {
      await createItem(item, digitalProductId, offerId)
    }
  }

  return {
    updateItem,
    createItem,
    saveItem,
  }
}
